module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-bar"
  }, [_c('aside', {
    staticClass: "menu"
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n      Admin\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('router-link', {
    class: {
      'is-active': _vm.$route.name === 'dashboard'
    },
    attrs: {
      "to": "dashboard"
    }
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      'is-active': _vm.$route.name === 'users'
    },
    attrs: {
      "to": "users"
    }
  }, [_vm._v("Users")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      'is-active': _vm.$route.name === 'projects'
    },
    attrs: {
      "to": "projects"
    }
  }, [_vm._v("Projects")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n      Debug\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('router-link', {
    class: {
      'is-active': _vm.$route.name === 'blogs'
    },
    attrs: {
      "to": "blogs"
    }
  }, [_vm._v("Blogs")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      'is-active': _vm.$route.name === 'components'
    },
    attrs: {
      "to": "components"
    }
  }, [_vm._v("Components")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55edeef8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideBar.vue
// module id = 817
// module chunks = 1